import { render } from "./kuaishouaccount.vue?vue&type=template&id=2c50d7e5&scoped=true"
import script from "./kuaishouaccount.vue?vue&type=script&lang=js"
export * from "./kuaishouaccount.vue?vue&type=script&lang=js"

import "./kuaishouaccount.vue?vue&type=style&index=0&id=2c50d7e5&lang=scss&scoped=true"

import exportComponent from "/Users/tangyinbo/workspace/front/syb/syb_webchat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c50d7e5"]])

export default __exports__